export default __webpack_public_path__ + "static/media/right-arrow-in-violet-circle.a6458f5b.bin";